<template>
    <div class="search-autocomplete-item">
        <div class="suggestion" v-if="item.type == 'text'">
            <v-icon class="icon">mdi-magnify</v-icon>
            <typo name="body-14-light" v-html="getSuggestion(item.suggestion)"></typo>
        </div>
        <div class="suggestion" v-if="item.type == 'code'">
            <div class="search-legend">
                {{ dico[item.subtype] ? dico[item.subtype] : item.subtype }}
            </div>
            <typo class="code" name="body-14-normal">{{ getCode(item.suggestion) }}</typo>
            <typo name="body-14-light" v-html="getSuggestion(item.label)"></typo>
        </div>
    </div>
</template>

<script>
import { truncate } from "lodash";
import { highlight } from "src/utils/highlight";

export default {
    components: {},
    props: ["item", "search"],
    methods: {
        getSuggestion(string) {
            string = truncate(string, { length: 80 });
            if (this.search) return this.highlight(string);
            else return string;
        },
        getCode(suggestion) {
            return suggestion;
        },
        highlight(string) {
            return highlight(string, this.search);
        },
    },
    computed: {
        dico() {
            return this.$privateDico.apenafs;
        },
    },
};
</script>

<style lang="sass" scoped>
.search-autocomplete-item

    .suggestion

        display: flex
        align-items: center

        .icon
            width: 8px
            height: 8px
            margin-left: 10px
            margin-right: 15px

            .code
                white-space: nowrap
                margin-right: 10px

            .highlight
                background: transparentize($color-main, 0.8)

            .search-legend
                font-size: 10px
                background: black
                color: white
                margin-right: 10px
                padding: 0 1px
                width: 70px
                text-align: center
                white-space: nowrap
                text-transform: uppercase
</style>
